module.exports = __webpack_public_path__ + "a87be886544d672debd80c9ff05ea287.svg";